import React from "react";

export default function Footer() {
  return (
      <div className="z-[5] flex flex-col items-center justify-between px-[20px] pt-2 pb-4 lg:flex-row lg:px-0 xl:pb-10">
        <p className="mb-4 text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-left">
        <span className="mb-4 text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-left">
          © {new Date().getFullYear()}
          <a href="https://vireliosoft.com" target="_blank" className="ml-1 font-bold text-navy-700 dark:text-white hover:text-brand-500 transition-all">
            Vireliosoft
          </a>. Tüm hakları saklıdır.
        </span>
        </p>
        <div className="flex flex-col md:flex-row items-center gap-4 lg:gap-8">
          <a href="mailto:contact@vireliosoft.com" className="text-sm font-medium text-gray-600 hover:text-navy-700 dark:text-gray-400 dark:hover:text-white">
            contact@vireliosoft.com
          </a>
          <a href="tel:+908508403917" className="text-sm font-medium text-gray-600 hover:text-navy-700 dark:text-gray-400 dark:hover:text-white">
            +90 850 840 39 17
          </a>
          <a href="https://randevupp.com" className="text-sm font-bold text-brand-500 hover:text-brand-600">
            RandevUpp.com
          </a>
        </div>
      </div>
  );
}